import { CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

import Modal from "../../../../../../components/Generic/Modal";

export const Wrapper = styled("div")(() => ({
  marginTop: 12,
  width: "100%",

  display: "flex",
  flexDirection: "column",
  gap: 12,
}));

export const StylishModal = styled(Modal)(() => ({
  width: 480,
  "@media screen and (max-width: 435px)": {
    width: 360,
  },
}));

interface CardProps {
  disabled?: boolean;
  active?: boolean;
}
const getColor = (isDisabled?: boolean, isActive?: boolean) => {
  if (isActive) return "#0055A4";
  if (isDisabled) return "#e4e7ec";

  return "";
};

export const Card = styled("div")((props: CardProps) => ({
  border: props.active ? "1px solid #0055A4" : "1px solid #e4e7ec",
  borderRadius: 8,
  padding: "11.15px 14px",

  display: "flex",
  alignItems: "flex-start",
  gap: "17.25px",

  cursor: props.disabled ? "initial" : "pointer",
  color: getColor(props.disabled, props.active),
  "& span": {
    color: getColor(props.disabled, props.active),
  },

  "&:hover": {
    border: props.disabled ? "1px solid #e4e7ec" : "1px solid #0055A4",
    color: props.disabled ? "#e4e7ec" : "#0055A4",
    "& span": {
      color: props.disabled ? "#e4e7ec !important" : "#0055A4 !important",
    },
  },
}));

export const WrapperCardBody = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  gap: 12,
}));

export const CardBody = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 4,
}));

export const CardTitle = styled("span")(() => ({
  color: "#344054",
  font: "700 14px/21px Manrope",
}));

export const CardText = styled("span")(() => ({
  color: "#475467",
  font: "400 14px/21px Manrope",
}));

export const LoadingContainer = styled("div")(() => ({
  display: "flex",
  height: "100%",
  alignItems: "center",
  justifyContent: "center",
}));

export const CardLoading = styled(CircularProgress)(() => ({
  color: "#0055A4",
}));
